import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Flex } from 'Common/components/Atoms/Flex';
import { actions as accountActions } from 'reducers/Account';
import LeftPane from '../LeftPane';
import RightPane from '../RightPane';
import { MuiTheme } from 'Common/theme';
import { useDispatch } from 'react-redux';

interface Props {
  fetchAccount: () => void;
}

const LandingPage = (props: Props) => {
  const { fetchAccount } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(accountActions.fetchAccount());
  }, [fetchAccount, dispatch]);
  return (
    <Flex minHeight="100vh">
      <ThemeProvider theme={MuiTheme}>
        <LeftPane />
        <RightPane />
      </ThemeProvider>
    </Flex>
  );
};

export default LandingPage;
